import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
import CompanyID from '@/App/Company/Entity/CompanyID'
import CompanyUserID from '@/App/CompanyUser/Entity/CompanyUserID'
import UserID from '@/App/User/Entity/UserID'
import {
    EditServiceOriginEnum,
    UserRoleEnum,
    type CompanyUserData,
} from '@/Shared/AutoGenerated/Main'
import type { TimeZoneEnum } from '@/Shared/AutoGenerated/TimeZoneEnum'

export default class CompanyUser {
    constructor(
        public readonly id: CompanyUserID,
        public readonly companyId: CompanyID,
        public readonly userId: UserID,
        public readonly role: UserRoleEnum,
        public readonly displayTimezone: TimeZoneEnum,
        public readonly isEnabled: boolean,
        public readonly isDeleted: boolean,
    ) {
        ensureNoUndefinedProperties(this)
    }

    isAdminOrOwner(): boolean {
        return (
            this.role === UserRoleEnum.Admin || this.role === UserRoleEnum.Owner
        )
    }

    isNotAdminOrOwner(): boolean {
        return this.isAdminOrOwner() === false
    }

    cannotDelete(): boolean {
        return this.role === UserRoleEnum.Owner
    }

    cannotChangeRole(): boolean {
        return this.cannotDelete()
    }

    // ------------------------
    // Hydration
    // ------------------------

    static hydrateSingleOrNull(
        entityData: CompanyUserData | null,
    ): CompanyUser | null {
        if (!entityData) {
            return null
        }

        return this.hydrateSingle(entityData)
    }

    static hydrateSingle(entityData: CompanyUserData): CompanyUser {
        return new CompanyUser(
            new CompanyUserID(entityData.id),
            new CompanyID(entityData.companyId),
            new UserID(entityData.userId),
            entityData.role,
            entityData.displayTimezone,
            entityData.isEnabled,
            entityData.isDeleted,
        )
    }

    static hydrateMultiple(entitiesData: CompanyUserData[]): CompanyUser[] {
        return entitiesData.map((entityData) => this.hydrateSingle(entityData))
    }
}
